import { useTranslation } from 'react-i18next';

import { Badge } from '@/shared/ui/Badge';

import { useCertificationsFor } from '../hooks/use-certifications';

/** "Vouched for by X" — active certifications a freelancer has received. */
export function CertificationsList({ freelancerId }: { freelancerId: string }): JSX.Element | null {
  const { t } = useTranslation();
  const query = useCertificationsFor(freelancerId);
  const list = query.data ?? [];
  if (list.length === 0) return null;

  return (
    <div className="stack">
      <span className="muted">{t('certifications.vouchedBy')}</span>
      <div className="wrap">
        {list.map((c) => (
          <Badge
            key={c.id}
            label={c.certifierName ?? t('certifications.certifier')}
            color="var(--color-primary)"
          />
        ))}
      </div>
    </div>
  );
}
